<template>
  <div class="content_main">
    <p class="content_normal">Swiftkash is a financial technology company. The purpose of our
      company is to allow more people to enjoy the convenience brought by technology financial
      services and to help more people solve financial loan problems. During the difficult economy
      recession, our company have stood by Nigerians to ensure they have access to soft and easily
      accessible loans. Many business people have benefited from our loans. Since your loan has been
      seriously overdue, our company has tried to communicate with you and your family for repayment
      many times, but it has not been resolved. Our company's legal affairs have completed the
      prelitigation investigation and have decided to take the aforementioned legal measures against
      you effectively.</p>
    <br />
    <p class="content_normal">We will now Take legal action against you in your name! The lawyer's
      letter will first be sent to your mailbox by e-mail, and the paper version of the lawyer's
      letter will be mailed to the police station at your home address now. Please check it
      carefully!</p>
    <br />
    <p class="content_normal">Swiftkash has reached cooperation with over 200 law firms in all 36
      states in Nigeria. Please contact us as soon as possible after receiving this notice to
      confirm acceptance of the application, and our company will contact your nearest law firm to
      negotiate and handle legal proceedings.</p>
    <br />
    <p class="content_normal">After receiving this notice, if you can handle the loan: please
      contact our support team on </p>
    <p class="content_normal">WhatsApp: 09010401147</p>
    <p class="content_normal">email: bill@swiftkash.ng </p>
    <br />
    <p class="content_normal"> If the funds are difficult, our company can reduce the penalty
      interest by 50% for you, after processing the arrears Our company will cancel the lawsuit
      against you and remove your overdue bad records. </p>
    <br />
    <p class="content_normal">Therefore, this letter requires you to pay and return it to the mail
      or company immediately.</p>
    <br />
    <p class="content_normal">Note: If you fail to pay, we will use all available methods to seek
      justice, which will obviously make you pay more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance of our best
      regards.</p>
    <br />
    <p class="content_normal">Regards.</p>
  </div>
</template>

<script>
export default {
  name: 'swiftM5',
};
</script>

<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;
  .content_main{
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }
  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
